module.exports = __webpack_public_path__ + "img/prime minister_end.b595e698.png";